/**
 * Check if a given object implements the StripeProductBoardCreateTemplate interface.
 */
export function instanceOfStripeProductBoardCreateTemplate(value) {
    let isInstance = true;
    isInstance = isInstance && "productIds" in value;
    isInstance = isInstance && "boardCode" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function StripeProductBoardCreateTemplateFromJSON(json) {
    return StripeProductBoardCreateTemplateFromJSONTyped(json, false);
}
export function StripeProductBoardCreateTemplateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productIds': json['productIds'],
        'boardCode': json['boardCode'],
        'description': json['description'],
    };
}
export function StripeProductBoardCreateTemplateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productIds': value.productIds,
        'boardCode': value.boardCode,
        'description': value.description,
    };
}
